import { isApiRequestError } from './app';

export function describeAppError(error: unknown, fallback: string): string {
  if (isApiRequestError(error)) {
    const apiMessage = (error.body as { error?: { message?: string } } | undefined)?.error?.message;
    return apiMessage || error.message || fallback;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
